import type { TFunction } from 'i18next';

import type { ReschedulingReason } from './types';

export const RESCHEDULING_REASON_TRANSLATION_KEYS: Record<
  ReschedulingReason,
  { title: string; description?: string }
> = {
  person_cancelled: {
    title: 'step1.reasons.personCancelled.title',
    description: 'step1.reasons.personCancelled.description',
  },
  customer_cancelled: {
    title: 'step1.reasons.customerCancelled.title',
    description: 'step1.reasons.customerCancelled.description',
  },
  other: {
    title: 'step1.reasons.other.title',
  },
};

export const getReschedulingReasonNotes = (
  reason: ReschedulingReason,
  t: TFunction<'shuffle'>
): string => {
  const { title, description } = RESCHEDULING_REASON_TRANSLATION_KEYS[reason];
  const titleText = t(title);

  if (!description) {
    return titleText;
  }

  return `${titleText} — ${t(description)}`;
};
